const PluginFilter = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function(filter: any) {
        this.player = null;
        this.el = null;

        if (filter) {
          if (typeof filter == 'string') {
            try {
              this.filter = JSON.parse(filter);
            } catch (e) {
              this.filter = {};
            }
          } else if (typeof filter == 'object') {
            this.filter = filter;
          } else {
            this.filter = {};
          }
        }
      },
      createEl: function(el: any, player: any) {
        this.player = player;
        this.el = el;
      },
      play: function() {
        if (this.filter) {
          let cssFilter = Object.keys(this.filter).map((key: string) => {
            return `${key}(${this.filter[key]}%)`;
          });

          let videoDom = this.el.querySelector('video');
          if (videoDom && cssFilter && cssFilter.length) {
            console.log(`${cssFilter.join(' ')} !important`);
            videoDom.style.filter = `${cssFilter.join(' ')}`;
          }
        }
      }
    })
  : null;

export default PluginFilter;
